module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e5b71c7ad17c883827e66eb4a6ac30d4.png";